import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { ButtonV2 } from "#src/commonV2/Button";
import { TagsInput } from "#src/commonV2/TagsInput";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";

type IUpdateDomainsModalProps = {
  open: boolean;
  callingAPI: boolean;
  newDomains: string[];
  setNewDomains: Dispatch<SetStateAction<string[]>>;
  onClose: () => void;
  onSave: () => void;
};

export const UpdateDomainsModal = ({
  open,
  callingAPI,
  newDomains,
  setNewDomains,
  onClose,
  onSave,
}: IUpdateDomainsModalProps) => {
  const { t } = useTranslation("workspace", {
    keyPrefix: "security.updateDomainsModal",
  });

  const [newDomain, setNewDomain] = useState<string>("");
  useEffect(() => {
    if (open) {
      setNewDomain("");
    }
  }, [open]);

  return (
    <ModalV2 open={open} onChangeOpen={onClose}>
      <span className="text-lg font-semibold text-gray-v2-900">
        {t("title")}
      </span>
      <div className="flex flex-col gap-6 text-md">
        {/* Desc */}
        <p className="text-md font-regular text-gray-v2-600">{t("desc")}</p>
        {/* Desc end */}
        <div className="flex flex-col gap-1.5">
          <p className="text-gray-v2-700 text-sm font-medium">
            {t("addDomains.label")}
          </p>
          <TagsInput
            tags={newDomains}
            setTags={setNewDomains}
            badgeColor="gray"
            placeholder={t("addDomains.placeholder")}
            searchText={newDomain}
            setSearchText={setNewDomain}
          />
        </div>
        <p className="text-md font-semibold text-warning-v2-500">{t("note")}</p>
        {/* Footer */}
        <div className="flex gap-3 justify-end">
          <ButtonV2
            variant="secondary"
            size="lg"
            color="gray"
            disabled={callingAPI}
            onClick={onClose}
          >
            <p>{t("button.cancel")}</p>
          </ButtonV2>

          <ButtonV2
            variant="primary"
            size="lg"
            pending={callingAPI}
            onClick={onSave}
          >
            <p>{t("button.save")}</p>
          </ButtonV2>
        </div>
        {/* Footer end */}
      </div>
    </ModalV2>
  );
};
